import _extends from "@babel/runtime/helpers/esm/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
import styled, { css } from 'styled-components';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import AsyncCreatableSelect from 'react-select/async-creatable';
import CreatableSelect from 'react-select/creatable';
import { variant } from 'styled-system';
import { Box } from '..';
import { spinnerAnimationStyled } from '../LoadingIndicator/loading-indicator.style';
import { get } from '../../styles/constant';
import { default as Theme } from './../../styles/theme';
import { inputErrorFocusVariant, inputFocusVariant } from '../../styles/FormElements';
const fit = variant({
  prop: 'fit',
  variants: {
    small: {
      minHeight: get('space.32'),
      fontSize: get('fontSizes.s'),
      borderRadius: get('borderRadius.s'),
      padding: "".concat(get('space.0'), " ").concat(get('space.8'))
    },
    medium: {
      minHeight: get('space.40'),
      fontSize: get('fontSizes.m'),
      borderRadius: get('borderRadius.m'),
      padding: "".concat(get('space.0'), " ").concat(get('space.12'))
    },
    large: {
      minHeight: get('space.48'),
      fontSize: get('fontSizes.l'),
      borderRadius: get('borderRadius.m'),
      padding: "".concat(get('space.0'), " ").concat(get('space.16'))
    }
  }
});
const selectVariant = variant({
  prop: 'variant',
  variants: {
    "default": {
      border: '1px solid'
    },
    vanity: {
      borderBottom: '2px solid',
      borderTop: get('space.0'),
      borderLeft: get('space.0'),
      borderRight: get('space.0'),
      borderRadius: get('space.0'),
      paddingLeft: get('space.0'),
      paddingRight: get('space.0')
    }
  }
});
const variants = {
  fit,
  selectVariant,
  inputErrorFocusVariant,
  inputFocusVariant
};
const commonStyle = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .MultiSelect__control {\n    ", "\n    ", "\n    ", "\n    border-color: ", ";\n    .MultiSelect__indicator.MultiSelect__dropdown-indicator {\n      padding: 0;\n      margin-right: ", ";\n    }\n  }\n\n  .MultiSelect__control--is-focused {\n    box-shadow: ", ";\n\n    .MultiSelect__single-value {\n      color: ", ";\n    }\n  }\n"])), variants.fit, variants.selectVariant, props => props.error ? variants.inputErrorFocusVariant : variants.inputFocusVariant, props => props.error ? get('colors.feedback.danger.normal') : get('colors.functional.grey.400'), props => props.fit === 'small' ? get('space.6') : props.fit === 'medium' ? get('space.10') : get('space.12'), props => props.variant === 'vanity' ? get('boxShadows.type.vanity.default') : get('boxShadows.type.basic.default'), get('colors.functional.grey.600'));
const Wrapper = styled(Box)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: ", ";\n  .MultiSelect__indicators button {\n    padding: 0;\n    min-height: auto;\n  }\n  i {\n    color: ", ";\n  }\n"])), props => props.width ? "".concat(props.width, "%") : '100%', get('colors.functional.grey.600'));
const RefWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([""])));
const LoadingIndicator = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  right: ", ";\n  top: ", ";\n  & svg {\n    animation: ", ";\n    height: ", ";\n    width: ", ";\n  }\n  & .spinner {\n    stroke-width: 12.5;\n    stroke: ", ";\n  }\n  & .track {\n    stroke-width: 12.5;\n    stroke: ", ";\n  }\n"])), get('space.30'), get('space.0'), spinnerAnimationStyled, props => props.fit === 'small' ? get('space.16') : get('space.24'), props => props.fit === 'small' ? get('space.16') : get('space.24'), get('colors.primary.blue.300'), get('colors.functional.grey.200'));
const CreatableReactSelect = styled(CreatableSelect)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n"])), commonStyle);
const StyledSelect = styled(Select)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", "\n"])), commonStyle);
const AsyncReactSelect = styled(AsyncSelect)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", "\n"])), commonStyle);
const AsyncCreatableReactSelect = styled(AsyncCreatableSelect)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", "\n"])), commonStyle);
const multiValue = provided => {
  return _extends(_extends({}, provided), {
    borderRadius: Theme.borderRadius.xl
  });
};
const multiValueRemove = provided => {
  return _extends(_extends({}, provided), {
    '&:hover': {
      backgroundColor: 'initial',
      color: 'initial'
    }
  });
};
const menu = provided => {
  return _extends(_extends({}, provided), {
    wordWrap: 'break-word'
  });
};
const CustomStyles = {
  MultiValue: multiValue,
  MultiValueRemove: multiValueRemove,
  Menu: menu
};
const Components = {
  AsyncReactSelect,
  AsyncCreatableReactSelect,
  Wrapper,
  RefWrapper,
  CreatableReactSelect,
  StyledSelect,
  LoadingIndicator,
  CustomStyles
};
export { Components };